import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CoacheeProfileMeetingsController } from 'presentation/page/profile/coachee-profile/coachee-profile-meetings/coachee-profile-meetings.controller';
import { ITask } from 'task/task';

@Component({
	selector: 'spr-coachee-profile-meetings-meeting',
	templateUrl: './coachee-profile-meetings-meeting.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'flex md:items-center md:p-3 px-1 py-3 md:space-x-3 even:bg-grey-alabaster md:flex-row flex-col md:space-y-0 space-y-3',
	},
})
export class CoacheeProfileMeetingsMeetingComponent {
	@Input() public task: ITask;

	constructor(public controller: CoacheeProfileMeetingsController) {}
}
